import request from "@/config/axios";

const mode = 'basedata'; // 对应config里的oDomains的key

// 获取当前最新定位
export function getNewestLocation(params,isload) {
  return request({
    url: '/v1/location/getNewestLocation',
    method: 'GET', 
    mode,
    noLoad:isload,
    params,
  })
}
// 获取学生指定日期的行动轨迹
export function getPathTrack(params) {
  return request({
    url: '/v1/location/getPathTrack',
    method: 'GET',
    mode, 
    params,
  })
}
// 发起推送当前位置上报请求
export function pushNewestLocation(params,isload) {
  return request({
    url: '/v1/location/pushNewestLocation',
    method: 'get',
    mode,
    noLoad:isload,
    params
  })
}
